import { render, staticRenderFns } from "./QuotationTable.vue?vue&type=template&id=27e6abf3"
import script from "./QuotationTable.vue?vue&type=script&lang=js"
export * from "./QuotationTable.vue?vue&type=script&lang=js"
import style0 from "./QuotationTable.vue?vue&type=style&index=0&id=27e6abf3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports